import type { QuestionnaireMode, QuestionnaireState } from "../../types";

export const handleSetConfigAction = (
  state: QuestionnaireState,
  payload: Record<string, unknown>,
): QuestionnaireState => {
  const mode: QuestionnaireMode =
    payload.variant === "stacked-sections" ? "stacked-sections" : "standard";

  return {
    ...state,
    config: payload,
    mode,
  };
};
